import React from "react";
import styles from './styles.module.scss';

export const IntegrationSectionSubHeader = ({ subHeader }) => {
    return (
        <div className={styles.subHeader}>
            {subHeader}
        </div>
    );
};